import { api } from '../../api';
import type { Branch, Program, Track, Cycle, Bundle } from '@repo/types';

export interface SharedBranchQueryParams {
  compact?: boolean;
}

export const SharedService = {
  getBranches: async (params?: SharedBranchQueryParams): Promise<{ data: Branch[] }> => {
    const response = await api.get<{ success: boolean; data: Branch[] }>('/shared/branches', {
      params,
    });
    return { data: response.data.data };
  },

  getPrograms: async (params?: any): Promise<{ data: Program[]; pagination: any }> => {
    const response = await api.get<{ success: boolean; data: Program[]; pagination: any }>(
      '/shared/programs',
      {
        params,
      }
    );
    return { data: response.data.data, pagination: response.data.pagination };
  },

  getTracks: async (): Promise<{ data: Track[] }> => {
    const response = await api.get<{ success: boolean; data: Track[] }>('/shared/tracks');
    return { data: response.data.data };
  },

  getLabels: async (): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/labels');
    return { data: response.data.data };
  },

  getCycles: async (): Promise<{ data: Cycle[] }> => {
    const response = await api.get<{ success: boolean; data: Cycle[] }>('/shared/cycles');
    return { data: response.data.data };
  },

  getBundles: async (params?: any): Promise<{ data: Bundle[] }> => {
    const response = await api.get<{ success: boolean; data: Bundle[] }>('/shared/bundles', {
      params,
    });
    return { data: response.data.data };
  },

  getWallets: async (): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/wallets');
    return { data: response.data.data };
  },

  getBankAccounts: async (): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/bank-accounts');
    return { data: response.data.data };
  },

  getInstructors: async (params?: any): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/instructors', {
      params,
    });
    return { data: response.data.data };
  },

  getMentors: async (params?: any): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/mentors', {
      params,
    });
    return { data: response.data.data };
  },

  getAgents: async (params?: { search?: string }): Promise<{ data: any[] }> => {
    const response = await api.get<{ success: boolean; data: any[] }>('/shared/agents', {
      params,
    });
    return { data: response.data.data };
  },

  searchStudent: async (payload: { phone?: string; email?: string }) => {
    const response = await api.post('/shared/search-student', payload);
    return response;
  },
};

export * from './enrollment';
